import {
  Home,
  Users,
  Activity,
  Shield,
  Image,
  Stethoscope,
  MessageSquareQuote,
  Globe,
  Megaphone,
  Newspaper,
  MonitorPlay,
  CalendarDays,
  BookText,
  BriefcaseBusiness,
  Download,
  FolderTree,
  UsersRound,
  Trophy,
  ScrollText,
  HeartPulse,
  ClipboardList,
  FileBadge,
  GraduationCap,
  MessagesSquare,
  Building2,
  BookOpenText,
  Microscope,
  UserRound,
  HeartHandshake,
  Milestone,
  Recycle,
  FileSearch,
  LibraryBig,
} from "lucide-react";

export const MenuItems = [
  {
    title: "Dashboard",
    url: "/",
    icon: Home,
    moduleKey: "dashboard",
    // Visible to all roles
  },
  {
    title: "Users",
    url: "/users",
    icon: Users,
    moduleKey: "users",
    allowedRoles: ["admin", "hr", "manager"],
  },
  {
    title: "Roles",
    url: "/roles",
    icon: Shield,
    moduleKey: "roles",
    allowedRoles: ["admin", "hr", "manager"],
  },
  {
    title: "Master",
    url: "/master",
    icon: FolderTree,
    moduleKey: "team-categories",
    allowedRoles: ["admin"],
    children: [
      {
        title: "Team Categories",
        url: "/master/team-categories",
        moduleKey: "team-categories",
        allowedRoles: ["admin"],
      },
    ],
  },
  {
    title: "Announcements",
    url: "/announcements",
    icon: Megaphone,
    moduleKey: "announcements",
    allowedRoles: ["admin"],
  },
  {
    title: "Advertisement Banner",
    url: "/advertisement-banner",
    icon: MonitorPlay,
    moduleKey: "advertisement-banner",
    allowedRoles: ["admin"],
  },
  {
    title: "Banners",
    url: "/banners",
    icon: Image,
    moduleKey: "banners",
    allowedRoles: ["admin"],
  },
  {
    title: "Specialities",
    url: "/specialities",
    icon: Microscope,
    moduleKey: "specialities",
    allowedRoles: ["admin"],
  },
  {
    title: "Patient Stories",
    url: "/patient-testimonials",
    icon: MessageSquareQuote,
    moduleKey: "patient-testimonials",
    allowedRoles: ["admin"],
  },
  {
    title: "Doctors' Perspective",
    url: "/doctor-testimonials",
    icon: Stethoscope,
    moduleKey: "doctor-testimonials",
    allowedRoles: ["admin"],
  },
    {
    title: "Awards",
    url: "/awards",
    icon: Trophy,
    moduleKey: "awards",
    allowedRoles: ["admin"],
  },
   {
    title: "Blogs",
    url: "/blogs",
    icon: Newspaper,
    moduleKey: "blogs",
    allowedRoles: ["admin"],
  },
  {
    title: "Events",
    url: "/events",
    icon: CalendarDays,
    moduleKey: "events",
    allowedRoles: ["admin"],
  },
  {
    title: "Newsletters",
    url: "/newsletters",
    icon: BookText,
    moduleKey: "newsletters",
    allowedRoles: ["admin"],
  },
  {
    title: "Career",
    url: "/career",
    icon: BriefcaseBusiness,
    moduleKey: "career",
    allowedRoles: ["admin"],
    children: [
      {
        title: "Current Openings",
        url: "/career/current-openings",
        moduleKey: "career",
        allowedRoles: ["admin"],
      },
      {
        title: "Applications",
        url: "/career/applications",
        moduleKey: "career",
        allowedRoles: ["admin"],
      },
      {
        title: "Teaching Positions",
        url: "/career/teaching-positions",
        moduleKey: "career",
        allowedRoles: ["admin"],
      },
      {
        title: "Internship Positions",
        url: "/career/internship-positions",
        moduleKey: "career",
        allowedRoles: ["admin"],
      },
    ],
  },
  {
    title: "Contact Requests",
    url: "/contact-requests",
    icon: MessagesSquare,
    moduleKey: "contact-requests",
    allowedRoles: ["admin"],
  },
    {
    title: "Our Journey",
    url: "/journey-milestones",
    icon: Milestone,
    moduleKey: "journey-milestones",
    allowedRoles: ["admin"],
  },
  {
    title: "Doctors",
    url: "/doctors",
    icon: UserRound,
    moduleKey: "doctors",
    allowedRoles: ["admin"],
  },
  {
    title: "Symptoms",
    url: "/symptoms",
    icon: HeartHandshake,
    moduleKey: "symptoms",
    allowedRoles: ["admin"],
  },
  {
    title: "Team",
    url: "/team",
    icon: UsersRound,
    moduleKey: "team",
    allowedRoles: ["admin"],
  },
  {
    title: "Committees",
    url: "/committees",
    icon: ClipboardList,
    moduleKey: "committees",
    allowedRoles: ["admin"],
  },
  {
    title: "News",
    url: "/news",
    icon: ScrollText,
    moduleKey: "news",
    allowedRoles: ["admin"],
  },
  {
    title: "Health Camps",
    url: "/health-camps",
    icon: HeartPulse,
    moduleKey: "health-camps",
    allowedRoles: ["admin"],
  },
  {
    title: "SEO Metadata",
    url: "/seo",
    icon: FileSearch,
    moduleKey: "seo",
    allowedRoles: ["admin"],
  },
  {
    title: "Biomedical Waste",
    url: "/bio-medical-waste",
    icon: Recycle,
    moduleKey: "bio-medical-waste",
    allowedRoles: ["admin"],
  },
  {
    title: "MSR Clause B.1.11",
    url: "/msr-clause",
    icon: LibraryBig,
    moduleKey: "msr-clause",
    allowedRoles: ["admin"],
  },
  {
    title: "Checkup Plans",
    url: "/checkup-plans",
    icon: ClipboardList,
    moduleKey: "checkup-plans",
    allowedRoles: ["admin"],
  },
  {
    title: "Results",
    url: "/results",
    icon: FileBadge,
    moduleKey: "results",
    allowedRoles: ["admin"],
  },
  {
    title: "Campus Life",
    url: "/campus-life",
    icon: GraduationCap,
    moduleKey: "campus-life",
    allowedRoles: ["admin"],
  },
  {
    title: "Student Testimonials",
    url: "/student-testimonials",
    icon: MessagesSquare,
    moduleKey: "student-testimonials",
    allowedRoles: ["admin"],
  },
  {
    title: "Facilities",
    url: "/facilities",
    icon: Building2,
    moduleKey: "facilities",
    allowedRoles: ["admin"],
  },
  {
    title: "Government Schemes",
    url: "/government-schemes",
    icon: Shield,
    moduleKey: "government-schemes",
    allowedRoles: ["admin"],
  },
  {
    title: "Corporate, Insurance & TPA",
    url: "/partners",
    icon: HeartHandshake,
    moduleKey: "partners",
    allowedRoles: ["admin"],
  },
  {
    title: "Journal of Medical Sciences",
    url: "/journals",
    icon: BookOpenText,
    moduleKey: "journals",
    allowedRoles: ["admin"],
  },
  {
    title: "Downloads",
    url: "/downloads",
    icon: Download,
    moduleKey: "downloads",
    allowedRoles: ["admin"],
  },
   {
    title: "Social Profiles",
    url: "/social-profiles",
    icon: Globe,
    moduleKey: "social-profiles",
    allowedRoles: ["admin"],
  },
  {
    title: "Activity Logs",
    url: "/activity-logs",
    icon: Activity,
    moduleKey: "activity-logs",
    allowedRoles: ["admin", "manager"],
  },
];
